var React = require('react');

function CashWithdrawal (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"30","cy":"30","r":"30","fill":"#FFCC00","key":0}),React.createElement("path",{"d":"M37.92 33.6V25.68H22.08M37.92 33.6H43.2V20.4H22.08V25.68M37.92 33.6V38.88H16.8V25.68H22.08M27.36 34.92C28.812 34.92 30 33.732 30 32.28C30 30.828 28.812 29.64 27.36 29.64C25.908 29.64 24.72 30.828 24.72 32.28C24.72 33.732 25.908 34.92 27.36 34.92Z","stroke":"#121212","strokeWidth":"2","strokeMiterlimit":"10","strokeLinejoin":"round","key":1})]);
}

CashWithdrawal.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = CashWithdrawal;

CashWithdrawal.default = CashWithdrawal;
